import { Component } from "react";
import Popup from "..";
import AppContext from "../../../contexts/AppContext";
import RectButton from "../../ui/button/RectButton";

class InvalidPopup extends Component {
    static contextType = AppContext;
    render() {
        return (
            <Popup className="try-again">
                <h3>Invalid Coupon Code</h3>
                <div className="column">
                    <p>Sorry! That coupon code is not valid. Please try again.</p>
                    <div></div>
                    <RectButton text="TRY AGAIN" onClick={()=>this.context.setPopup(null)} />
                </div>
            </Popup>
        )
    }
}

export default InvalidPopup;